import { get, writable } from "svelte/store";
import { appManager } from "../../../../../../AppManager";
/**
 * Manages a profile layer.
 */
export class MatrixAssignmentRowManager {
    constructor(parent, tripScenarioId, data) {
        this.isVisible = writable(false);
        this.tripScenarioId = tripScenarioId;
        this.parent = parent;
        this.data = data;
        this.progress = writable(1);
        this.canRemove = writable(false);
        this.id = writable(this.data.id);
        this.visible = writable(this.data.visible);
        this.color = writable({ color: this.data.color, visualizationType: this.data.visualizationType });
        this.profile = writable(this.data.profile);
        this.profile.subscribe(p => {
            if (this.data.profile == p)
                return;
            this.data.profile = p;
            this.save().then(_ => {
                this.parent.refreshTrips();
            });
        });
        this.color.subscribe(c => {
            if (this.data.color == c.color && this.data.visualizationType == c.visualizationType)
                return;
            this.data.color = c.color;
            this.data.visualizationType = c.visualizationType;
            this.save().then();
        });
        this.visible.subscribe(v => {
            if (this.data.visible == v)
                return;
            this.data.visible = v;
            this.isVisible.set(v && get(this.parent.visible));
            this.save().then();
        });
        this.isVisible.set(get(this.visible) && get(this.parent.visible));
        this.parent.visible.subscribe(v => {
            this.isVisible.set(v && get(this.visible));
        });
        this.parent.getMatrixAssignmentRows().subscribe(pls => {
            this.onParentLayersChanged(pls);
        });
    }
    onParentLayersChanged(profileLayers) {
        if (profileLayers.length > 1) {
            this.canRemove.set(true);
        }
        else {
            this.canRemove.set(false);
        }
    }
    async save() {
        const token = await appManager.api.getAccessToken();
        const result = await appManager.api.projects.updateMatrixAssignment({
            tripScenarioId: this.tripScenarioId,
            id: this.data.id,
            data: this.data,
            accessToken: token
        });
    }
    /**
     * Gets the is visible store, combines all visible states into one.
     */
    getIsVisible() {
        return this.isVisible;
    }
    /**
     * Gets the id of the matrix.
     */
    getMatrixId() {
        return get(this.parent.id);
    }
    /**
     * Gets the progress.
     * @returns The progress.
     */
    getProgress() {
        return this.progress;
    }
    /**
     * The available routing profiles.
     *
     * @returns The profiles.
     */
    getAvailableProfiles() {
        return this.parent.getAvailableProfiles();
    }
    /**
     * Gets the can remove store.
     */
    getCanRemove() {
        return this.canRemove;
    }
    /**
     * Deletes this layer.
     */
    async delete() {
        await this.parent.deleteAssignment(this.data.id);
    }
    /**
     * Copies this layer.
     */
    async copy() {
        await this.parent.addAssignment(this.data);
    }
}
